import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmtpSettingsComponent } from './smtp-settings/smtp-settings.component';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SmtpSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule
  ],
  providers: [],
  exports: [SmtpSettingsComponent]
})
export class SmtpSettingsModule {
  customElementComponent: Type<any> = SmtpSettingsComponent;
}

